import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import MenuSetupService from "../../../services/KangarooServices/MenuSetupService";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Select from "react-select";

const MenuForm = ({
  isOpen,
  toggle,
  selectedItem,
  typeData,
  fetchType,
  fetchMenu,
}) => {
  const [selectedRadio, setSelectedRadio] = useState("pages"); // "pages" or "listedSubPage"
  const [parentPage, setParentPage] = useState([]);
  const [blogList, setBlogList] = useState([]);
  const [selectedBlogOption, setSelectedBlogOption] = useState(null);
  const [selectedPageType, setSelectedPageType] = useState(null);
  const [menuList, setMenuList] = useState([]);
  console.log("🚀 ~ MenuForm ~ menuList:", menuList);
  // Enum for sub-pages
  const pageType = [
    { label: "Blogs", value: 1 },
    { label: "DestinationCountries", value: 2 },
    { label: "Events", value: 3 },
    { label: "TestPreparations", value: 4 },
  ];

  // Fetch all parent pages
  const fetchMenuList = async () => {
    try {
      const response = await MenuSetupService.getTypeDetail(
        selectedType?.value
      );
      setMenuList(response);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchParentList = async () => {
    try {
      const response = await MenuSetupService.getParentPage();
      setParentPage(response);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch blogs by enum ID
  const fetchBlogList = async (pageTypeId) => {
    if (!pageTypeId) return;
    try {
      const response = await MenuSetupService.getListByPage(pageTypeId);
      setBlogList(response);
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      id: selectedItem?.id || null,
      title: selectedItem?.title || "",
      url: selectedItem?.url || "",
      orderIndex: selectedItem?.orderIndex || 0,
      isActive: selectedItem?.isActive ?? true,
      menuTypeId: selectedItem?.menuTypeId || null,
      parentId: selectedItem?.parentId || null,
      pageType: selectedItem?.pageType || null, // NEW
      isFromPage: selectedItem?.isFromPage ?? true, // NEW
      isExternal: selectedItem?.isExternal || true,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          ...values,
          pageType:
            selectedRadio === "listedSubPage" && selectedPageType
              ? selectedPageType.value
              : null,
          isFromPage: selectedRadio === "pages",
        };

        if (values.id) {
          await MenuSetupService.update(values.id, payload);
          toast.success("Menu updated successfully");
        } else {
          await MenuSetupService.create(payload);
          toast.success("Menu created successfully");
        }

        fetchType();
        fetchMenu();
        toggle();
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong!");
      }
    },
  });
  const menuOptions =
    menuList?.menus?.map((type) => ({
      value: type.id,
      label: type.title || type.name,
    })) || [];
  const selectedMenu = menuOptions.find(
    (option) => option.value === formik.values.parentId
  );
  console.log("🚀 ~ MenuForm ~ selectedMenu:", selectedMenu);
  const handleMenuChange = (selectedOption) => {
    formik.setFieldValue(
      "parentId",
      selectedOption ? selectedOption.value : null
    );
  };
  // Options
  const parentOptions = parentPage.map((page) => ({
    value: page.id,
    label: page.title || page.name,
  }));

  const typeOptions =
    typeData?.map((type) => ({ value: type.id, label: type.name })) || [];

  const selectedParent = parentOptions.find(
    (option) => option.value === formik.values.parentId
  );

  const selectedType = typeOptions.find(
    (option) => option.value === formik.values.menuTypeId
  );
  console.log("🚀 ~ MenuForm ~ selectedType:", selectedType);

  // Handlers
  const handleParentChange = (selectedOption) => {
    formik.setFieldValue(
      "parentId",
      selectedOption ? selectedOption.value : null
    );
    if (selectedRadio === "pages" && selectedOption) {
      const slug = selectedOption.label.toLowerCase().replace(/\s+/g, "-");
      formik.setFieldValue("url", `/${slug}`);
    }
  };

  const handlePageTypeChange = (selectedOption) => {
    setSelectedPageType(selectedOption);
    setSelectedBlogOption(null);
    formik.setFieldValue("url", "");

    if (selectedOption) {
      fetchBlogList(selectedOption.value); // pageType enum ID
      formik.setFieldValue("pageType", selectedOption.value); // set in Formik
    } else {
      setBlogList([]);
      formik.setFieldValue("pageType", null);
    }
  };

  const handleBlogChange = (selectedOption) => {
    setSelectedBlogOption(selectedOption);

    if (selectedOption && selectedPageType) {
      const pageSlug = selectedPageType.label
        .toLowerCase()
        .replace(/\s+/g, "-");
      const blogSlug = selectedOption.label.toLowerCase().replace(/\s+/g, "-");
      formik.setFieldValue("url", `/${pageSlug}/${blogSlug}`);
    }
  };

  const handleTypeChange = (selectedOption) => {
    formik.setFieldValue("menuTypeId", selectedOption?.value || null);
  };
  useEffect(() => {
    fetchMenuList();
  }, [selectedType?.value]);

  useEffect(() => {
    fetchParentList();
  }, []);
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Menu Form</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <Label>
              Title <span className="text-danger">*</span>
            </Label>
            <Input
              name="title"
              type="text"
              value={formik.values.title}
              onChange={formik.handleChange}
            />
          </div>

          <div className="mb-3">
            <Label>
              Url <span className="text-danger">*</span>
            </Label>
            <Input
              name="url"
              type="text"
              value={formik.values.url}
              onChange={formik.handleChange}
            />
          </div>

          <div className="mb-3">
            <FormGroup check inline>
              <Input
                type="radio"
                name="menuTypeRadio"
                value="pages"
                checked={selectedRadio === "pages"}
                onChange={() => setSelectedRadio("pages")}
              />{" "}
              <Label check>Pages</Label>
            </FormGroup>
            <FormGroup check inline>
              <Input
                type="radio"
                name="menuTypeRadio"
                value="listedSubPage"
                checked={selectedRadio === "listedSubPage"}
                onChange={() => setSelectedRadio("listedSubPage")}
              />{" "}
              <Label check>Sub page</Label>
            </FormGroup>
          </div>

          {/* Pages */}
          {selectedRadio === "pages" && (
            <div className="mb-3">
              <Label>Select Page</Label>
              <Select
                options={parentOptions}
                value={selectedParent || null}
                onChange={handleParentChange}
                placeholder="Select Page"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({ ...base, padding: "0.3rem" }),
                }}
              />
            </div>
          )}

          {/* Sub Pages */}
          {selectedRadio === "listedSubPage" && (
            <>
              <div className="mb-3">
                <Label>Select Page Type</Label>
                <Select
                  options={pageType}
                  value={selectedPageType}
                  onChange={handlePageTypeChange}
                  placeholder="Select Page Type"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({ ...base, padding: "0.3rem" }),
                  }}
                />
              </div>
              <div className="mb-3">
                <Label>Select Blog</Label>
                <Select
                  options={blogList.map((blog) => ({
                    value: blog.id,
                    label: blog.title || blog.name,
                  }))}
                  value={selectedBlogOption}
                  onChange={handleBlogChange}
                  placeholder="Select Blog"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({ ...base, padding: "0.3rem" }),
                  }}
                />
              </div>
            </>
          )}

          <div className="mb-3">
            <Label>Index</Label>
            <Input
              name="orderIndex"
              type="number"
              value={formik.values.orderIndex}
              onChange={formik.handleChange}
            />
          </div>
          <div className="mb-3">
            <Label>Menu type</Label>
            <Select
              id="menuTypeId"
              name="menuTypeId"
              options={typeOptions}
              value={selectedType || null}
              onChange={handleTypeChange}
              placeholder="Select Menu Type"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({ ...base, padding: "0.3rem" }),
              }}
            />
          </div>
          <div className="mb-3">
            <Label>Parent Menu</Label>{" "}
            <Select
              id="parentId"
              name="parentId"
              options={menuOptions}
              value={selectedMenu || null}
              onChange={handleMenuChange}
              placeholder="Select Parent Menu"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (baseStyles) => ({ ...baseStyles, padding: "0.3rem" }),
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="isExternal" className="form-label">
              Is External?
            </label>
            <input
              type="checkbox"
              id="isExternal"
              name="isExternal"
              checked={formik.values.isExternal || false}
              onChange={() =>
                formik.setFieldValue("isExternal", !formik.values.isExternal)
              }
              className="form-check-input"
            />
          </div>

          <div className="text-end">
            <button type="submit" className="btn btn-primary">
              {formik.values.id ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default MenuForm;
